/**
 * @description 举报的接口
 * @date 2021-04-20 23:43:10
 * @see http://api.umucdn.cn/project/46/interface/api/cat_227
 */

import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/microapi/base/report';

export const ReportAPI = {
    /**
     * 获取举报的相关分类数据
     */
    REPORT_POLICY: {
        url: BasePath + '/policy',
        type: API_TYPE.GET,
    },

    /**
     * 举报一个对象(内容，用户)
     */
    REPORT_ISSUE: {
        url: BasePath + '/issue',
        type: API_TYPE.POST,
    },
};
